<template>
  <div>
    <div v-if = "CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN.length>0" class="alert-container mb-2" >
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN}}</strong></div>
              </div>
            </div>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div class="large-panel pt-3" v-if="hidePanelIfNotOnPreviewPage">
      <span class="main-title">Supplier engagement request</span>

      <div class="row no-gutters">
        <div class="col-12 mt-2 p-4 form-outline">
          <div class="justify-content-end">
            <button
              class="close close-btn"
              @click="navigateToHome()"
              :disabled="isLoading"
            >
              <font-awesome-icon icon="times" />
            </button>
          </div>

          <alert-message class="px-md-5 px-0 my-3" v-if="errorMessage"></alert-message>
          <progress-bar v-model="steps" class="px-md-5 px-0 hide-progress-bar" :technologyIsFromReseller="isTechnologyFromReseller"></progress-bar>
          <div v-for="(tab, index) in tabItems" :key="index" class="px-md-5 px-0">
            <span v-if="tab.component === currentTab">
              <h4>{{ tab.name }}</h4>
              Request by {{ currentUser.firstName }} {{ currentUser.lastName }}
              <div class="float-md-right">
                page {{ index + 1 }}/{{ tabItems.length }}
              </div>
              <br />
              <hr />
            </span>
          </div>

          <!-- Only show below when supplier info is fetched from all suppliers tab -->
          <div
            class="preview-notification mx-md-5 mx-0"
            v-if="userEngagedWithSupplier"
          >
            Please fill out the supplier engagement request form to engage with
            <strong>{{ supplierOnboardRequestData.supplierName }}</strong>
          </div>
          <component class="px-md-5 px-0" :is="currentComponent"></component>
        </div>
        <!--        <div class="col-md-3 col-12 mt-2 px-md-5 px-0">-->
        <!--          &lt;!&ndash;TODO: Enable related resources once related resources are curated&ndash;&gt;-->
        <!--          &lt;!&ndash;<related-resources />&ndash;&gt;-->
        <!--        </div>-->
      </div>
      <support :showSupportWhenLoading="true"></support>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import GeneralInformation from "@/components/OneIntakeForm/GeneralInformation";
import SupplierInformation from "@/components/OneIntakeForm/SupplierInformation";
import AdditionalDetails from "@/components/OneIntakeForm/AdditionalDetails";
import PreviewDetails from "@/components/OneIntakeForm/PreviewDetails";
import ShortForm from "@/components/OneIntakeForm/ShortForm";
import { Validator } from "vee-validate";
import RelatedResources from "@/components/OneIntakeForm/RelatedResources";
import LoadingSpinner from "@/components/LoadingSpinner";
import supplierRequestMixin from "@/mixins/supplierRequestMixin";
import Support from "@/components/Support";
import AlertMessage from "@/components/AlertMessage";
import api from "../../api";
import CONSTANTS from "@/store/constants";
import ProgressBar from "@/components/ProgressBar.vue";
Validator.extend("phone", (value) => {
  const pattern = new RegExp("^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$");
  return pattern.test(value);
});

export default {
  name: "Home",
  components: {ProgressBar, LoadingSpinner, GeneralInformation, SupplierInformation, AdditionalDetails, PreviewDetails, ShortForm, RelatedResources, Support, AlertMessage,},
  mixins: [supplierRequestMixin],
  computed: {
    ...mapGetters(["tabItems", "isLoading", "currentUser", "products", "supplierOnboardRequestData", "isSupplierNameLoaded", "supplierDraftData", "onBoardingReturnedRequests", "errorMessage", "supplierCountryList", "onBoardingPendingRequests","onBoardingCompletedRequests","suppliersNameList","isSupplierNameSheetUpdated"]),
    ...mapState(["currentTab"]),
    userEngagedWithSupplier() {
      return this.isSupplierNameLoaded && this.activeTabIndex === 0;
    },
    hidePanelIfNotOnPreviewPage() {
      if (this.currentComponent === "PreviewDetails") {
        return true;
      } else {
        return !this.isLoading;
      }
    },
  },
  watch: {
    currentTab(val) {
      this.currentComponent = val
      this.activeTabIndex = this.tabItems.findIndex(tab => tab.component === val)
    },
    isTechnologyFromReseller(newVal) {
      const supplierStep = this.steps.find((step) => step.label === 'SupplierInformation');
      if (supplierStep) {
        supplierStep.name = newVal ? 'Supplier & Reseller information' : 'Supplier Information';
      }
    },

  },
  data() {
    return {
      activeTabIndex: 0,
      currentComponent: "",
      watchersToBePopulated: [],
      mountedData: {},
      steps: [
        {label: "GeneralInformation", name: "General information", component: "GeneralInformation", onStep: 1,},
        {label: "SupplierInformation", name: "Supplier information", component: "SupplierInformation", onStep: 2,},
        {label: "AdditionalDetails", name: "Data and security", component: "AdditionalDetails", onStep: 3,},
        {label: "PreviewDetails", name: "Preview details", component: "PreviewDetails", onStep: 4,},
      ],
    };
  },
  created: function () {
    this.initializeOneIntakeData();
  },
  methods:{
    ...mapMutations(["setCurrentTab","setSupplierOnboardRequestData","setDraftId","setWatchers","setIsRequestingForWatchers","setIsLoading","setErrorMessage","setReturnedRequestId","setSuppliersNameList","setIsSupplierNameSheetUpdated"]),
    ...mapActions(["fetchVendorById","fetchUserDrafts","fetchAllOnBoardingRequests","fetchAllProducts","clearAllFormsData","getSupplierCountryListData"]),
    validateSupplierCountryListData(){
      if (!this.supplierCountryList || this.supplierCountryList.length === 0)
      {
        this.getSupplierCountryListData()
      }
    },
    getCurrentStep(data) {
      if (this.isValidString(data)) {
        let mappedStatus = this.statusMap.find(
          (status) => status.component.toLowerCase() === data.toLowerCase()
        );
        return mappedStatus
          ? { currentStep: mappedStatus.currentStep, name: mappedStatus.name }
          : 0;
      }
      return 0;
    },
    async initializeOneIntakeData() {
      this.setIsLoading(true);

      if(this.isSupplierNameSheetUpdated === false)
      {
        this.updateSupplierNamesList()
      }
      
      if(!this.products || this.products.length === 0) {
        await this.fetchAllProducts(false)
      }

      if (this.$route.meta.tab === "DraftIntakeForm") {
        await this.getDraftRequestsData();
      } else if (this.$route.meta.tab === "ReturnedRequestsForm") {
        await this.getReturnedRequestsData();
      } else if (this.$route.meta.tab === "DuplicateIntakeForm") {
        await this.getDuplicateRequestsData();
      } else if (this.$route.query.vendorId) {
        try {
          await this.fetchVendorById(this.$route.query.vendorId);
          await this.updateUserInfo(); // Pre-updates the vendor name in supplier page
        } catch (error) {
          await this.updateUserInfo(); // Opens blank intake form to onboard new vendor
        }
      } else {
        await this.updateUserInfo();
      }
      this.validateSupplierCountryListData();

      this.setIsLoading(false);
    },
    updateSupplierNamesList(){
      api.updateSupplierNameSheet().then((response)=>{
        if(response && response.data && response.data.data && response.data.data.updateSupplierNameSheet && response.data.data.updateSupplierNameSheet.isSupplierNameSheetUpdated)
        {
          this.setIsSupplierNameSheetUpdated(true)
          this.fetchSupplierNamesList()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    async fetchSupplierNamesList(){
      api.getPresignedUrl(CONSTANTS.SUPPLIER_NAMES_FILE_NAME,true)
          .then((response) => {
            // store csv file data into a list
            if(response && response.data && response.data.data && response.data.data.fetchAttachmentPreSignedUrl && response.data.data.fetchAttachmentPreSignedUrl.preSignedUrl)
            {
              const file = response.data.data.fetchAttachmentPreSignedUrl.preSignedUrl;
              api.getFile(file,'csv')
                  .then(blob => {
                    let downloadedBlob = new Blob([blob.data], {type: blob.headers["content-type"]});
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(downloadedBlob);
                    reader.onload = () => {
                      let csvData = reader.result
                      let textDecoder = new TextDecoder('utf-8'); 
                      let decodedCsvContent = textDecoder.decode(new Uint8Array(csvData));
                      let csvRecordsArray = decodedCsvContent.split(/\r\n|\n/);
                      csvRecordsArray = csvRecordsArray.map(record => record.trim())
                      //set all but 1st record to supplier list
                      csvRecordsArray = csvRecordsArray.map(record => record.replace(/^"|"$/g, ''))
                      this.setSuppliersNameList(csvRecordsArray.slice(1,))
                    }
                  }).catch((error) => {
                    console.log(error)
                    });
            }
          }).catch((error) => {
        console.log(error)
      })
    },
    async checkAndSetWatchersData(mountedData){
      //This check here is to make sure we are getting watchers back, if so setting it to load in the form
      if (mountedData.watcherUserIds && mountedData.watcherUserIds !== "") {
        this.setIsRequestingForWatchers(true);
        await this.fetchDataForWatchers(mountedData);
      }
    },
    async getDraftRequestsData() {
      await this.fetchUserDrafts(false);
      this.mountedData = this.supplierDraftData.find((data) => data.id === this.$route.params.id);
      this.handleEdgeCasesForOneIntake();
      await this.getSupplierOnBoardRequestById(true);
      this.setWatchers(this.watchersToBePopulated);
      this.setOneIntakeFormFields();
      this.mountedData === undefined ? this.redirectToForbiddenPage() : this.setSupplierOnboardRequestData(this.mountedData);
      await this.getUserInfo();
      this.setDraftId(this.$route.params.id);
    },
    async getReturnedRequestsData() {
      await this.fetchAllOnBoardingRequests(false);
      this.mountedData = this.onBoardingReturnedRequests.find((data) => data.id === this.$route.params.id);
      this.handleEdgeCasesForOneIntake();
      delete this.mountedData.recommendedByGovernment;
      delete this.mountedData.onBehalfOfAutodeskCustomer;
      delete this.mountedData.anyRelationshipWithAutodesk;

      await this.getSupplierOnBoardRequestById(false);
      this.setWatchers(this.watchersToBePopulated);
      this.setOneIntakeFormFields();
      this.mountedData === undefined ? this.redirectToForbiddenPage() : this.setSupplierOnboardRequestData(this.mountedData);
      await this.getUserInfo();
      this.setReturnedRequestId(this.$route.params.id);
    },
    async getDuplicateRequestsData() {
      await this.fetchAllOnBoardingRequests(false);
      this.mountedData = this.$route.params.isCompletedCase ? this.onBoardingCompletedRequests.find((data) => data.id === this.$route.params.id) :this.onBoardingPendingRequests.find((data) => data.id === this.$route.params.id);
      this.mountedData.duplicateForm = true;
      this.handleEdgeCasesForOneIntake();
      await this.getSupplierOnBoardRequestById(false);
      //Deleting existing case id
      delete this.mountedData.id;
      this.setWatchers(this.watchersToBePopulated);
      this.setOneIntakeFormFields();
      this.mountedData === undefined ? this.redirectToForbiddenPage() : this.setSupplierOnboardRequestData(this.mountedData);
      await this.getUserInfo();
    },
    handleEdgeCasesForOneIntake() {
      //Converting below-mentioned properties to lowercase as it comes as it might come as uppercase for the initial alphabet.
      if (this.isValidString(this.mountedData.customerDataProcessed)) {
        this.mountedData.customerDataProcessed = this.convertToLowercase(
          this.mountedData.customerDataProcessed
        );
      }
      if (this.isValidString(this.mountedData.technologyFromReseller)) {
        this.mountedData.technologyFromReseller = this.convertToLowercase(
          this.mountedData.technologyFromReseller
        );
      }
      if (this.isValidString(this.mountedData.corporateCardPayment)) {
        this.mountedData.corporateCardPayment = this.convertToLowercase(
          this.mountedData.corporateCardPayment
        );
      }
    },
    setOneIntakeFormFields() {
      //This check is to ensure that if companyBuyingServices is not received in any circumstance, we ensure it is initialised to an empty Array.
      if (this.mountedData && !this.mountedData.companyBuyingServices) {
        this.mountedData.companyBuyingServices = [];
        this.mountedData.companyBuyingServiceCheckBox = [];
      }
    },
    onNavItemClicked(index) {
      this.activeTabIndex = index;
      this.currentComponent = this.tabItems[index].component;
    },
    redirectToForbiddenPage() {
      let errorPage = process.env.VUE_APP_EH_URL + "/forbidden";
      location.href = errorPage;
    },
    fetchDataForWatchers(mountedData) {
      let watchersList = mountedData.watcherUserIds.split(",");
      watchersList.map((watcher) => {
        api.getUserInfo(watcher).then((response) => {
          if (response) {
            this.watchersToBePopulated.push(response.data);
          } else {
            this.setErrorMessage(CONSTANTS.ERROR_MESSAGE);
          }
        });
      });
    },
    async getSupplierOnBoardRequestById(isDraft) {
      const response = isDraft
        ? await api.fetchSupplierOnBoardDraftRequestById(this.mountedData.id)
        : await api.fetchSupplierOnBoardRequestById(this.mountedData.id);
      if (response && response.data.data.fetchSupplierOnBoardDraftRequestById) {
        //  Adding Attachments and watcherIds from API to the same mountedData
        this.mountedData.attachments =
          response.data.data.fetchSupplierOnBoardDraftRequestById.attachments;
        this.mountedData.watcherUserIds =
          response.data.data.fetchSupplierOnBoardDraftRequestById.watcherUserIds;
        //Calling below method to set the watcher's after mountedData property has watcherIds property in it.
        await this.checkAndSetWatchersData(this.mountedData);
      } else if (
        response &&
        response.data.data.fetchSupplierOnBoardRequestById
      ) {
        //  Adding Attachments and watcherIds from API to the same mountedData
        this.mountedData.attachments =
          response.data.data.fetchSupplierOnBoardRequestById.attachments;
        this.mountedData.watcherUserIds =
          response.data.data.fetchSupplierOnBoardRequestById.watcherUserIds;
        //Calling below method to set the watcher's after mountedData property has watcherIds property in it.
        await this.checkAndSetWatchersData(this.mountedData);
      } else {
        this.setErrorMessage(CONSTANTS.ERROR_MESSAGE);
      }
    },
  },
  beforeDestroy() {
    this.clearAllFormsData();
  },
};
</script>

<style scoped>
@media (max-width: 1000px) {
  .nav-tabs li {
    width: 100% !important;
  }
}

@media (max-width: 800px) {
  .hide-progress-bar {
    display: none;
  }
}

.nav-tabs,
.nav-link {
  border: none;
  border-radius: 0;
  border: 0 !important;
}
.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: inherit;
}
.nav-tabs li a.active {
  color: #0696d7;
  font-weight: bold;
  border-bottom: 4px #0696d7 solid !important;
}
.navitem-active {
  color: #0696d7 !important;
  font-weight: bold !important;
  border-bottom: 2px #0696d7 solid !important;
  padding: 1px;
}
.nav-tabs {
  border: none;
}
.nav-tabs {
  border: none;
}
.nav-tabs li a {
  min-width: 100px;
  height: 75px;
  padding-top: 25px;
  text-align: center;
  color: #000;
  font-size: 14px;
}
</style>

<style>
.section-complete {
  color: #87bc40 !important;
}

.form-outline {
  border: 1px solid #ced4da;
}

.large-panel {
  padding-bottom: 30px;
  margin: 0px 0px 15px 0px;
}
</style>
